/* eslint-disable @stylistic/quotes */

import { useStore } from '../../../api/index.ts';

const asciiArt = (displayName: string | null, userId: string | null) => {
  return "\n\n" +
"░█████████                        ░██          ░███     ░███                                                        \n" +
"░██     ░██                       ░██          ░████   ░████                                                        \n" +
"░██     ░██  ░██████    ░███████  ░██    ░██   ░██░██ ░██░██  ░██████   ░████████   ░██████    ░████████  ░███████  \n" +
"░█████████        ░██  ░██    ░██ ░██   ░██    ░██ ░████ ░██       ░██  ░██    ░██       ░██  ░██    ░██ ░██    ░██ \n" +
"░██   ░██    ░███████  ░██        ░███████     ░██  ░██  ░██  ░███████  ░██    ░██  ░███████  ░██    ░██ ░█████████ \n" +
"░██    ░██  ░██   ░██  ░██    ░██ ░██   ░██    ░██       ░██ ░██   ░██  ░██    ░██ ░██   ░██  ░██   ░███ ░██        \n" +
"░██     ░██  ░█████░██  ░███████  ░██    ░██   ░██       ░██  ░█████░██ ░██    ░██  ░█████░██  ░█████░██  ░███████  \n" +
"                                                                                                     ░██            \n" +
"                                                                                               ░███████             \n" +
(displayName != null ? "\nHello " + displayName.split(' ')[0] + "!\n" : "") +
"\nBuild: " + import.meta.env.VITE_BUILD +
"\nRegion: " + import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION +
"\nRack Version: " + import.meta.env.VITE_DEFAULT_RACK_VERSION +
"\nApp: " + import.meta.env.VITE_FIREBASE_PROJECT_ID +
(userId != null ? "\nUser ID: " + userId : "");
};

export function consoleWelcome() {
  const store = useStore();
  const displayName = store.user != null && store.user?.displayName != null ? store.user?.displayName : null;
  const userId = store.user != null && store.user?.uid != null ? store.user?.uid : null;
  window.console.log(`%c ${asciiArt(displayName, userId)}`, 'color: #11B981;');
}
